<template>
  <div class="neo-section">
    <div class="neo-container">
      <div data-aos="fade-up">
        <el-row type="flex" justify="center">
          <el-col :md="16">
            <h2 style="margin-bottom: 50px; text-align: center">FAQs</h2>
            <div class="faqs">
              <el-collapse v-model="activeFaq" accordion>
                <el-collapse-item
                  v-for="faq in faqs"
                  :key="faq.name"
                  :name="faq.name"
                >
                  <template #title>
                    <h6
                      style="
                        font-size: 1.125rem;
                        font-family: 'Jost', sans-serif;
                      "
                    >
                      {{ faq.question }}
                    </h6>
                  </template>
                  <p>{{ faq.answer }}</p>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div class="note">
              <h6>Accepted IDs in Nigeria:</h6>
              <p>- Bank Verification Number (BVN)</p>
              <p>- National Identification Number (NIN)</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NeoFaqs",
  data() {
    return {
      activeFaq: "8",
      faqs: [
        {
          name: "8",
          question: "How Do I send money with NEO?",
          answer:
            "With NEO, sending money is fast, easy, and free of extra transfer charges. Just sign up, add your loved ones in Nigeria, and transfer money. You can choose to pay right away or pay later for flexibility. Every transfer can improve your credit score. Keep making timely payments and you can get a NEO Card for your loved ones in Nigeria to use anywhere in Nigeria. Use the NEO App to send money, track spending, control spending, and set up automatic monthly payments."
        },
        {
          name: "1",
          question: "Who Can Receive a NEO Card?",
          answer:
            "Start by making regular money transfers with NEO to any Nigerian account. With a consistent record of timely repayments, you can qualify for a NEO Card. This allows you to issue cards to your loved ones in Nigeria, provided they have a valid ID like a BVN or NIN.",
        },
        {
          name: "2",
          question: "What Makes the NEO Card Special?",
          answer:
            "It's just like a regular credit card! Your family in Nigeria can shop in stores or online, anywhere Mastercard/Visa is accepted.",
        },
        {
          name: "3",
          question: "Managing the NEO Card: How Does it Work?",
          answer:
            "It's super simple! With the NEO App, you can send money, keep an eye on spending, pause the card, or set up easy monthly payments.",
        },
        {
          name: "4",
          question: "When Will the NEO Card Arrive?",
          answer: "Expect the NEO card in Nigeria within about 10 days.",
        },
        {
          name: "5",
          question: "Why Do You Need My Government ID?",
          answer:
            "Your Government ID helps us confirm who you are and lets us give you credit rewards for sending money overseas. We keep it safe and only use it for a quick check with our US Banking Partners.\n",
        },
        {
          name: "6",
          question: "Will My Credit Score Be Affected?",
          answer:
            "No stress – just looking at your credit offer doesn’t touch your score. If you go for our credit, we do a full check, but timely payments can actually improve your score!\n",
        },
        {
          name: "7",
          question: " Is NEO Right for Me If My Credit Isn't Great?",
          answer:
            "Absolutely! Start with our Credit Builder card. Back it with your funds (up to $500), and with regular payments, you could move to an unsecured credit line and get your deposit back.\n",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.el-collapse-item__header {
  height: 70px !important;
}

.note {
  margin: 30px 0;
  text-align: center;

  h6 {
    font-size: 1rem;
    margin-bottom: 10px;
  }

  p {
    font-size: 1rem;
  }
}
</style>
